import {request, serviceUrl} from "@/utils/request";

//获取当前登录的户信息
export function getAccountInfo() {
    return request({
        url: serviceUrl.iamService + '/account'
    })
}

//获取用户列表(id和name)
export function getAccountList() {
    return request({
        url: serviceUrl.iamService + '/account/list'
    })
}

//修改用户密码 原密码、新密码
export function modifyPassword(oldPassword, password) {
  return request({
    method: 'POST',
    url: serviceUrl.iamService + '/account/modify/password',
    params: {oldPassword, password}
  })
}

//校验密码安全等级 0低1中2高
export function verifyPwLevel(password) {
  return request({
    url: serviceUrl.iamService + '/account/verifyPwLevel',
    params: {password}
  });
}

//是否需要强制更新密码 0 未到达强制更新时间 其他数字为当前设置的强制更新时间
export function validationPwSecurity(password) {
  return request({
    url: serviceUrl.iamService + '/account/validationPwSecurity',
    params: {password}
  });
}

//校验当前登录的用户密码是否正确
export function passwordVerifiers(password) {
  return request({
    url: serviceUrl.iamService + '/account/password/verifiers',
    params:{password}
  })
}

